import { typedObjectKeys } from '@multitenancy-spa/utils/esm/utils/typed-object-keys';

const deepMerge = <
	T extends Record<string, any>,
	K extends Record<string, any>,
>(
	obj1: T,
	obj2: K,
): T & K => {
	typedObjectKeys(obj2).forEach((key) => {
		if (Object.prototype.hasOwnProperty.call(obj2, key)) {
			if (
				typeof obj2[key] === 'object' &&
				typeof obj1[key as keyof T] === 'object'
			) {
				const mergedValue = deepMerge(obj1[key as keyof T], obj2[key]);
				obj1[key as keyof T] = mergedValue as T[keyof T];
			} else {
				obj1[key as keyof T] = obj2[key] as unknown as T[keyof T];
			}
		}
	});
	return obj1 as T & K;
};

export default deepMerge;
